/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.torget-shipping\":\"Liikkeessä oleva kuorma-auto\"}");